import { render, staticRenderFns } from "./fuzzySearch.vue?vue&type=template&id=0070a288&scoped=true&"
import script from "./fuzzySearch.vue?vue&type=script&lang=ts&"
export * from "./fuzzySearch.vue?vue&type=script&lang=ts&"
import style0 from "./fuzzySearch.vue?vue&type=style&index=0&id=0070a288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070a288",
  null
  
)

export default component.exports